export enum PAGES {
	HOME = 'service-intervals-catalog',
}

export const REMOTE = {
	NAME: 'service_intervals_catalog',
	MANIFEST_PATH: '/remotes/service-intervals-catalog/mf-manifest.json',
} as const;
